import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, ArrowRight } from 'lucide-react';
import { companyInfo, services } from '../../data/mock';

export const Footer = () => {
  return (
    <footer className="bg-primary-dark text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Info */}
          <div>
            <div className="font-bold text-2xl tracking-tighter uppercase mb-6">
              Stolarija<span className="text-secondary">Leskovac</span>
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Vrhunska izrada i montaža ALU i PVC stolarije po meri. 
              Kvalitet, tradicija i poverenje su naši glavni aduti.
            </p>
            <div className="flex gap-4">
              <a href={companyInfo.facebook} className="bg-white/10 p-2 rounded-full hover:bg-secondary transition-colors">
                <Facebook size={20} />
              </a>
              <a href={companyInfo.instagram} className="bg-white/10 p-2 rounded-full hover:bg-secondary transition-colors">
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold uppercase mb-6 border-b-2 border-secondary inline-block pb-2">Brzi Linkovi</h3>
            <ul className="space-y-3">
              <li><Link to="/" className="text-gray-300 hover:text-secondary flex items-center gap-2"><ArrowRight size={14} /> Početna</Link></li>
              <li><Link to="/o-nama" className="text-gray-300 hover:text-secondary flex items-center gap-2"><ArrowRight size={14} /> O Nama</Link></li>
              <li><Link to="/galerija" className="text-gray-300 hover:text-secondary flex items-center gap-2"><ArrowRight size={14} /> Galerija</Link></li>
              <li><Link to="/recenzije" className="text-gray-300 hover:text-secondary flex items-center gap-2"><ArrowRight size={14} /> Recenzije</Link></li>
              <li><Link to="/kontakt" className="text-gray-300 hover:text-secondary flex items-center gap-2"><ArrowRight size={14} /> Kontakt</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold uppercase mb-6 border-b-2 border-secondary inline-block pb-2">Usluge</h3>
            <ul className="space-y-3">
              {services.slice(0, 6).map((service) => (
                <li key={service.id}>
                  <Link to={service.path} className="text-gray-300 hover:text-secondary flex items-center gap-2">
                    <ArrowRight size={14} /> {service.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold uppercase mb-6 border-b-2 border-secondary inline-block pb-2">Kontakt</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="text-secondary shrink-0 mt-1" size={20} />
                <span className="text-gray-300">{companyInfo.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="text-secondary shrink-0" size={20} />
                <a href={`tel:${companyInfo.phone}`} className="text-gray-300 hover:text-white">{companyInfo.phone}</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="text-secondary shrink-0" size={20} />
                <a href={`mailto:${companyInfo.email}`} className="text-gray-300 hover:text-white">{companyInfo.email}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center text-gray-400 text-sm">
          <p>&copy; {new Date().getFullYear()} Stolarija Leskovac. Sva prava zadržana.</p>
        </div>
      </div>
    </footer>
  );
};
